import { STIP_BASE_URL } from "../props";
import { useSelector } from "react-redux";
import { useGet } from "../common/fetchServices";
import { notBlank } from "../util/ext";
import querystring from "querystring";
import { formatDateString } from "../util/stringFormat";

const getCspUrl = auth => {
  if (notBlank(auth.currentOrganization)) {
    const organizationId = auth.currentOrganization.id;
    return `${STIP_BASE_URL}/organizations/${organizationId}/projects`;
  } else {
    return `${STIP_BASE_URL}/projects`;
  }
};

const getSubmissionCountUrl = (auth, fromDate) => {
  const organizationId = notBlank(auth.currentOrganization)
    ? auth.currentOrganization.id
    : null;

  const baseUrl = notBlank(organizationId)
    ? `${STIP_BASE_URL}/organizations/${organizationId}/submissions/project-count`
    : `${STIP_BASE_URL}/projects/submission-count`;

  return notBlank(fromDate)
    ? `${baseUrl}?${querystring.encode({ fromDate })}`
    : baseUrl;
};

export const getSubmissionReportUrl = (projectId, start, end) => {
  const startDate = formatDateString(start);
  const endDate = formatDateString(end);
  return `${STIP_BASE_URL}/reports/${projectId}/submissions?${querystring.encode(
    { startDate, endDate },
  )}`;
};

const getCspSubmissionContentUrl = (auth, fromDate) => {
  const organizationId =
    auth.currentOrganization && auth.currentOrganization.id;

  const baseUrl = `${STIP_BASE_URL}/organizations/${organizationId}/submissions/type-count`;
  return notBlank(fromDate)
    ? `${baseUrl}?${querystring.encode({ fromDate })}`
    : baseUrl;
};

export const useCsps = () => {
  const auth = useSelector(state => state.auth);
  const url = getCspUrl(auth);

  return useGet(["csp", { url }], url);
};

export const useCspSubmissionContentCount = fromDate => {
  const auth = useSelector(state => state.auth);
  const url = getCspSubmissionContentUrl(auth, fromDate);
  return useGet(["csp-type-count", { url }], url);
};

export const useCspSubmissionCount = fromDate => {
  const auth = useSelector(state => state.auth);
  const url = getSubmissionCountUrl(auth, fromDate);
  return useGet(["csp-submission-count", { url }], url);
};

// export const useCspSubmissionReport = (projectId, startDate, endDate) => {
//   const auth = useSelector(state => state.auth);
//   const url = getSubmissionReportUrl(auth, projectId, startDate, endDate);
//   return useGet(["csp-submission-report", { url }], url);
// };
